import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { daysPerYear } from '@datapad/data-model';
import { useTree } from '@fluidframework/react/alpha';
import React from 'react';
import { CalendarMonthOutlined, Check, Close, Delete, Edit } from '@mui/icons-material';
import { Box, FormControl, FormLabel, IconButton } from '@mui/material';
import { IntegerField } from './IntegerField.js';
export function EditableCalendarDateView({ date, deleteDate, linkToCalendar, }) {
    useTree(date);
    const [editing, setEditing] = React.useState(false);
    if (editing) {
        return (_jsx(CalendarDateEditForm, { value: date, submit: ({ year, day }) => {
                date.year = year;
                date.day = day;
                setEditing(false);
            }, cancel: () => {
                setEditing(false);
            } }));
    }
    else {
        return (_jsxs(Box, { display: 'flex', flexDirection: "row", width: "100%", justifyContent: "space-between", children: [_jsxs(Box, { children: [_jsx(IconButton, { onClick: () => linkToCalendar?.(date), disabled: linkToCalendar === undefined, children: _jsx(CalendarMonthOutlined, {}) }), date.toShortString()] }), _jsxs(Box, { children: [_jsx(IconButton, { onClick: () => {
                                setEditing(true);
                            }, children: _jsx(Edit, {}) }), deleteDate && (_jsx(IconButton, { onClick: () => {
                                deleteDate();
                            }, children: _jsx(Delete, {}) }))] })] }));
    }
}
export function CalendarDateEditForm({ label, value, submit, cancel, }) {
    const [year, setYear] = React.useState(value?.year);
    const [day, setDay] = React.useState(value?.day);
    const isValidYear = year !== undefined && Number.isInteger(year) && year > 0;
    const isValidDay = day !== undefined && Number.isInteger(day) && day >= 0 && day < daysPerYear;
    const canSubmit = isValidYear && isValidDay;
    return (_jsxs(Box, { display: 'flex', flexDirection: "row", width: "100%", justifyContent: "space-between", children: [_jsx(CalendarDateFields, { label: label, value: { year, day }, onYearChange: setYear, onDayChange: setDay }), _jsxs(Box, { children: [_jsx(IconButton, { onClick: () => {
                            submit({ year: year, day: day });
                        }, disabled: !canSubmit, children: _jsx(Check, {}) }), _jsx(IconButton, { onClick: cancel, children: _jsx(Close, {}) })] })] }));
}
export function CalendarDateField({ label, value, onChange, }) {
    const [year, setYear] = React.useState(value?.year);
    const [day, setDay] = React.useState(value?.day);
    function isValidYear(year) {
        return year !== undefined && Number.isInteger(year) && year > 0;
    }
    function isValidDay(day) {
        return day !== undefined && Number.isInteger(day) && day >= 0 && day < daysPerYear;
    }
    return (_jsx(CalendarDateFields, { label: label, value: { year, day }, onYearChange: (newYear) => {
            setYear(newYear);
            if (isValidYear(newYear) && isValidDay(day)) {
                onChange({ year: newYear, day });
            }
        }, onDayChange: (newDay) => {
            setDay(newDay);
            if (isValidYear(year) && isValidDay(newDay)) {
                onChange({ year, day: newDay });
            }
        } }));
}
function CalendarDateFields({ label, value, onYearChange, onDayChange, }) {
    return (_jsx(Box, { display: 'flex', flexDirection: "row", children: _jsxs(FormControl, { children: [label && _jsx(FormLabel, { children: label }), _jsx(IntegerField, { value: value?.year, label: "Year", onChange: onYearChange, min: 0 }), _jsx(IntegerField, { value: value?.day, label: "Day", min: 0, max: daysPerYear, onChange: onDayChange })] }) }));
}
//# sourceMappingURL=CalendarDateField.js.map